module.exports = __webpack_public_path__ + "static/media/bannerMobile@1x.a1e16dc8.jpg";